"use client";

import { ReactNode, useRef } from "react";
import { ensureSiteStorageVersion } from "@/app/shared/storage-version";

export default function StorageVersionGuard({
  children,
}: {
  children: ReactNode;
}) {
  const checkedRef = useRef(false);

  if (!checkedRef.current) {
    checkedRef.current = true;
    ensureSiteStorageVersion();
  }

  return <>{children}</>;
}
